import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getReturnReasons } from '../../../../actionCreators/returnExchange';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
import Select from '../../../../CommonComponents/DropDown/DropDown';
import ReturnProductCard from './ReturnProductCard';

function SelectReason(props) {
  const {
    SecStep,
    item,
    returnReasons,
    getReturnReasons,
    reason,
    isExpandable,
    setIsExpandable,
    returnItemId,
    returnEligibiliyDetails,
    dataLocale,
  } = props;
  const {
    RETURN_MODE,
    SELECT_REASON,
    CHANGE,
    PLEASE_TELL_US_THE_PROBLEM_WITH_PRODUCT,
    PLEASE_ELABORATE_MORE_ON_FITTING_ISSUES,
    NEXT,
  } = dataLocale;
  const data = sessionStorageHelper.getItem('returnStep') || {};
  const [primaryReason, setPrimaryReason] = useState(data.primaryReason || '');
  const [secondaryReason, setSecondaryReason] = useState(data.secondaryReason || '');
  const [secondaryReasons, setSecondaryReasons] = useState([]);
  const [initialRender, setInitialRender] = useState(false);
  const classification = item && item.classification;
  useEffect(() => {
    setPrimaryReason(data.primaryReason || reason);
    if (classification) {
      getReturnReasons(classification);
    }
  }, []);
  useEffect(() => {
    if (classification) {
      setInitialRender(true);
      getReturnReasons(classification);
    }
  }, [classification]);
  useEffect(() => {
    if (primaryReason && returnReasons) {
      const sReason =
        returnReasons && returnReasons.find(returnReason => returnReason.reason === primaryReason);
      setSecondaryReasons(sReason?.secondaryReasons);
      setSecondaryReason(data.secondaryReason || '');
    }
  }, [primaryReason, returnReasons]);
  const handleChange = event => {
    setPrimaryReason(event.target.value);
  };
  const handleSecondaryReason = event => {
    setSecondaryReason(event.target.value);
  };
  const handleReturnReason = () => {
    const pReason =
      returnReasons && returnReasons.find(returnReason => returnReason.reason === primaryReason);
    const sReason =
      secondaryReasons &&
      secondaryReasons.find(returnReason => returnReason.reason === secondaryReason);
    const returnReasonIds = {
      primaryReasonId: pReason.id,
      secondaryReasonId: sReason.id,
    };
    let productToReturn = sessionStorageHelper.getItem('returnProduct') || {};
    productToReturn = {
      ...productToReturn,
      returnReasons: returnReasonIds,
    };
    sessionStorageHelper.setItem('returnProduct', productToReturn);
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    if (!returnStep.secondStep) {
      SecStep(true);
      setIsExpandable(RETURN_MODE);
      returnStep = {
        ...returnStep,
        setStoreAddress: false,
        primaryReason: pReason.reason,
        secondaryReason: sReason.reason,
        isExpandable: RETURN_MODE,
        secondStep: true,
      };
    } else {
      returnStep = {
        ...returnStep,
        primaryReason: pReason.reason,
        secondaryReason: sReason.reason,
      };
      setIsExpandable(returnStep.isExpandable);
    }
    sessionStorageHelper.setItem('returnStep', returnStep);
  };
  return (
    <div className="bora-8 margin-10 order-box">
      <div className={`padding-15 ${isExpandable !== SELECT_REASON ? 'bg-white' : 'bg-cyan'}`}>
        <span
          className={`fs15 futur-std  ${
            isExpandable !== SELECT_REASON ? 'text-color-grey fw500' : 'fw600'
          }`}
        >
          {PLEASE_TELL_US_THE_PROBLEM_WITH_PRODUCT}
        </span>
        {isExpandable !== SELECT_REASON && (
          <span
            className="float-right margin-r10 text-uppercase text-link"
            onClick={() => setIsExpandable(SELECT_REASON)}
          >
            {CHANGE}
          </span>
        )}
        {isExpandable !== SELECT_REASON && (
          <div className="margin-t5">
            <span className="margin-l20">{primaryReason}</span> :
            <span className="margin-l8 text-color-grey">{secondaryReason}</span>
          </div>
        )}
      </div>
      {isExpandable === SELECT_REASON && (
        <div className="margin-b10" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div
            style={{
              textAlign: 'center',
              flex: 1,
              marginLeft: '5px',
              marginRight: '5px',
              padding: '5px',
              marginTop: '15px',
            }}
          >
            <ReturnProductCard
              selectedReasonComponent
              item={item}
              returnEligibiliyDetails={returnEligibiliyDetails}
              returnItemId={returnItemId}
            />{' '}
          </div>
          <div className="margin-t15 margin-l5 margin-r10 padding-5">
            <div className="margin-t10 margin-b20">
              <Select
                id="demo-simple-select-outlined"
                labelId="demo-simple-select-outlined-label"
                menuItemStyles={{ fontSize: '14px' }}
                styles={{ fontSize: '14px' }}
                value={primaryReason}
                values={
                  initialRender &&
                  returnReasons?.map(returnReason => ({
                    value: returnReason.reason,
                    display: returnReason.reason,
                    onChange: handleChange,
                  }))
                }
              />
            </div>
            <span className="fs14 fw400 text-color_pale_black text-color-grey">
              {PLEASE_ELABORATE_MORE_ON_FITTING_ISSUES}
            </span>
            <div className="margin-t10 margin-b20">
              <Select
                id="demo-simple-select-outlined"
                labelId="demo-simple-select-outlined-label"
                menuItemStyles={{ fontSize: '14px' }}
                styles={{ margin: 0, minWidth: '360px', fontSize: '14px' }}
                value={secondaryReason}
                values={secondaryReasons?.map(secondaryReason => ({
                  value: secondaryReason.reason,
                  display: secondaryReason.reason,
                  onChange: handleSecondaryReason,
                }))}
              />
            </div>
            {primaryReason && secondaryReason && (
              <Button
                className="float-right margin-t15 margin-r15 text-color-white bg-color-primary no-decoration flex-basis-20 text-center block bora-4 fw700 text-uppercase"
                onClick={handleReturnReason}
              >
                {NEXT}
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  returnReasons: state.returnExchange.returnReasons,
});

function mapDispatchToProps(dispatch) {
  return {
    getReturnReasons: classification => dispatch(getReturnReasons(classification)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectReason);
